import { breakpoints } from '@toggle/design-system';
import { ButtonRoot } from '@toggle/design-system/src/components/button/Button.styles';
import styled from 'styled-components';

export const Container = styled.header`
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-rows: 1fr;
  grid-template-areas: 'logo button search';

  justify-items: space-between;
  align-content: center;
  border-bottom: 1px solid var(--border-default);
  padding: 12px 16px;
  min-height: 60px;

  @media ${breakpoints.lg} {
    grid-template-columns: auto 1fr auto;
    justify-items: center;
    grid-template-areas: 'logo search button';
  }
`;

export const LogoContainer = styled.div`
  grid-area: logo;
  display: flex;
  align-items: center;
`;

export const SearchContainer = styled.div`
  grid-area: search;
  margin-left: 10px;

  @media ${breakpoints.lg} {
    margin-left: 0px;
  }
`;

export const ButtonsContainer = styled.div`
  grid-area: button;
  display: flex;
  align-items: center;
`;

export const FaqLink = styled(ButtonRoot)`
  border: none;
  text-decoration: none;
`;

export const ExploreMore = styled(ButtonRoot)`
  display: none;

  @media ${breakpoints.lg} {
    display: flex;
  }
  margin-left: 12px;
  text-decoration: none;
`;
